import { CreateTransaction } from '~/features/common/Balance/BalanceHistory/CreateTransaction'
import { TransactionMoveFundsTypeEnum } from '~/shared/config/enums'
import { BreadcrumbsList } from '~/shared/ui/Breadcrumbs'

const breadcrumbs: BreadcrumbsList = [
  { titleI18n: 'balances', link: '/balance/balance-histories' },
  { titleI18n: 'transaction creation' },
]

function CreateSpendingTransactionPage() {
  return (
    <CreateTransaction
      moveFundsType={TransactionMoveFundsTypeEnum.SPENDING}
      breadcrumbs={breadcrumbs}
      isCreating
    />
  )
}

export default CreateSpendingTransactionPage
